// iframe com altura fixa (100vh) sempre reserva uma tela cheia na impressão, mesmo quando o
// conteúdo real é bem menor (ex.: Ficha do Protocolo ROC) — resultado: páginas em branco sobrando
// depois do conteúdo, ou scroll interno escondendo o fim do documento. Ajusta a altura do iframe pro
// tamanho real do documento carregado (srcDoc).
export default function useAlturaAutoIframe() {
    return (event) => {
        const iframe = event.target;
        const doc = iframe.contentWindow?.document;
        if (!doc) return;

        const estiloSemScroll = doc.createElement("style");
        estiloSemScroll.textContent = `
            html, body, * { overflow: visible !important; }
            html, body { height: auto !important; max-height: none !important; }
        `;
        doc.head?.appendChild(estiloSemScroll);

        // documentElement.scrollHeight sozinho erra em HTML legado (body com margem/float): às vezes
        // devolve menos que o conteúdo real e o fim do documento fica cortado. Pega o maior valor.
        const medirAltura = () => Math.max(
            doc.documentElement?.scrollHeight ?? 0,
            doc.documentElement?.offsetHeight ?? 0,
            doc.body?.scrollHeight ?? 0,
            doc.body?.offsetHeight ?? 0
        );

        const FOLGA_ALTURA = 4;

        const aplicarAltura = () => {
            const altura = medirAltura();
            if (altura) iframe.style.height = `${altura + FOLGA_ALTURA}px`;
        };

        aplicarAltura();

        // Documentos vindos de integrações externas (ex.: ficha da CTR do RCC) trazem imagens
        // (brasão, logos) cujo carregamento pode terminar depois do 'load' do iframe — a altura
        // medida acima fica menor que o real e corta o fim do conteúdo. Reaplica quando essas
        // imagens terminarem de carregar e observa qualquer mudança de tamanho do documento.
        Array.from(doc.images ?? []).forEach((img) => {
            if (!img.complete) img.addEventListener("load", aplicarAltura, { once: true });
        });

        if (typeof ResizeObserver !== "undefined" && doc.documentElement) {
            new ResizeObserver(aplicarAltura).observe(doc.documentElement);
        }
    };
}
